export const LINK_SENT = 'LINK_SENT';
export const APP_DETAILS = 'APP_DETAILS';
